export default "__VITE_ASSET__1f60ef88__"